const convertDateTo = (dateFrom: string, dateTo: string, departureDate: string): string => {
  if (dateFrom.indexOf('M') !== -1) {
    return departureDate;
  }
  if (dateTo.indexOf('T') !== -1 || dateTo.indexOf('W') !== -1) {
    return 'Any';
  }
  return dateTo.replace(/-/g, '');
};

export default convertDateTo;
